import {
  Component,
  OnInit,
  Input,
  HostBinding,
  ChangeDetectorRef,
  ElementRef,
  NgZone,
  Output,
  EventEmitter
} from '@angular/core';

import {property, map, each, cloneDeep, assignIn, find} from 'lodash';

@Component({
  selector: 'fihe-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
  host: {
    '(document:click)': 'onClick($event)',
    '(document:keydown)': '_keydown($event)',
  }
})
export class DropdownComponent implements OnInit {

  @Input('id') id;
  @Input('filter') filter;
  @Output() changeIt = new EventEmitter();
  @Output() search = new EventEmitter();
  @HostBinding('class.cell') iscell: boolean = true;
  $element;

  visible = false;

  selectedValue;

  stored = false;

  constructor(private ref: ChangeDetectorRef, private myElement: ElementRef, public zone: NgZone) {

  }

  onClick(event) {
    if (!this.myElement.nativeElement.contains(event.target)) {
      this.visible = false;
     // this.$element.find('.dropdown-panel').foundation('close');
    }

  }

  _keydown(event) {
    if (this.$element.find('.dropdown-panel').hasClass('is-open') && event.keyCode == 13) {
      this.store();
      this.visible = false;
      //this.$element.find('.dropdown-panel').foundation('close');
    }
  }

  ngOnInit() {
    this.$element = window['jQuery'](this.myElement.nativeElement);
    // preselect Radio and geo
    if (this.filter.form_type == 'radio' || this.filter.form_type == 'geo') {
      var selected = find(this.filter.items, {checked: true});
      if (selected) {
        this.selectedValue = selected.value;
      }
    }


    this.$element.on('show.zf.dropdown', '[data-dropdown]', () => {
      this.stored = cloneDeep(this.filter.items);
      this.ref.detectChanges();
    });
    this.$element.on('hide.zf.dropdown', '[data-dropdown]', () => {
      if (this.stored != false) {
        assignIn(this.filter.items, this.stored);
        this.ref.detectChanges();
        this.changeIt.emit(this.filter);
      }
    });
  }

  toggleDropdown() {
    this.visible = !this.visible;
    //this.$element.find('.dropdown-panel').foundation('toggle');
  }


  ngAfterViewInit() {
  //  this.$element.foundation();
  }

  store() {
    this.stored = false;
    this.ref.detectChanges();
    this.search.emit(this.filter);
    this.visible = false;
  }


  /**
   * Check on Change and Detect Check all Stuff
   **/
  change($event) {
    if (this.filter.form_type == 'checkbox') {

      // Check ALL
      if ($event.value == -1 && $event.checked) {

        // Disable all Other
        each(this.filter.items, (item) => {
          if (item.value != -1) {
            item.checked = false;
          }
        });

        // Uncheck all
      } else if ($event.value == -1 && !$event.checked) {
        // Check if ther es another checked
        setTimeout(() => {
          this.setAllFlag(true);
        });

      } else {

        // Check if non selected, then select all
        if (find(this.filter.items, {checked: true})) {
          this.setAllFlag(false);
        } else {
          this.setAllFlag(true);
        }

      }

      //this.ref.markForCheck();
      this.ref.detectChanges();
    } else if (this.filter.form_type == 'radio' || this.filter.form_type == 'geo') {

      each(this.filter.items, (item) => {
        item.checked = item.value == this.selectedValue
      });
    }


    try {
      if (window['ga']) {
        window['ga']('send', 'Search', 'Filter', this.filter.label, 1);
      }
    } catch (e) {
    }

    //  this.changeIt.emit(this.filter);
  }


  setAllFlag(_value) {

    each(this.filter.items, (item) => {
      if (item.value == -1) {
        item.checked = _value;
      }
    });

  }


}



// WEBPACK FOOTER //
// ./src/app/dropdown/dropdown.component.ts